import { render, staticRenderFns } from "./changelog-drawer.vue?vue&type=template&id=2c83ebec&scoped=true&"
import script from "./changelog-drawer.vue?vue&type=script&lang=js&"
export * from "./changelog-drawer.vue?vue&type=script&lang=js&"
import style0 from "./changelog-drawer.vue?vue&type=style&index=0&id=2c83ebec&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c83ebec",
  null
  
)

export default component.exports